import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ActionPreviewImpactSummarySection } from '../../../../../services/gable/gable.service';

/**
 * `impact_summary` section: a small label above a tinted panel with one
 * or two lines describing what will happen on approve. Tone controls the
 * panel background — `info` is the default (light blue, $app-ai-banner-bg),
 * `success` is mint, `warning` is peach.
 */
@Component({
    selector: 'app-ap-impact-summary-section',
    templateUrl: './impact-summary-section.component.html',
    styleUrls: ['./impact-summary-section.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
})
export class ActionPreviewImpactSummarySectionComponent {
    @Input({ required: true }) section!: ActionPreviewImpactSummarySection;
    /** When provided, replaces the server-supplied static primary text. */
    @Input() primaryOverride: string | null = null;
    /** When provided, replaces the server-supplied static secondary text. */
    @Input() secondaryOverride: string | null = null;

    get displayPrimary(): string {
        return this.primaryOverride ?? this.section.primary;
    }

    get displaySecondary(): string | null {
        return this.secondaryOverride !== undefined ? this.secondaryOverride : (this.section.secondary ?? null);
    }
}
